module.exports = __webpack_public_path__ + "static/image/font/pc/bmyeonsung-5@3x.ver2_0_2.jpg?a886bc6b";